

export const Work = [
    {
      id:1,
        name:"Campaign Smart Contract",
        description:["Crowdfunding smart contract. Donate to campaign and vote. Made with Solidity, web3, Next.js on Rinkeby Ethereum test network."],
       
        imgSrc: 'https://github.com/marins1897/PortfolioMS/blob/main/src/data/DataImages/Campaign.jpg?raw=true',
        demo:"",
        github:"https://github.com/marins1897/campaign-SmartContract",
    },
    {
      id:2,
        name:"Lottery Smart Contract",
        description:["Buy lottery ticket on blockchain and be a winner. Made with Solidity, web3, React on Rinkeby Ethereum test network."],
       
        imgSrc: 'https://github.com/marins1897/PortfolioMS/blob/main/src/data/DataImages/Lottery.jpg?raw=true',
        demo:"",
        github:"https://github.com/marins1897/lottery-SmartContract",
    },
    {
        id:3,
        name:"News AI App",
        description:["AI App build in React.js with Alan AI. Search news by voice. Talk with App. Search by categories, terms or sources. Chat with AI."],
       
        imgSrc: 'https://github.com/marins1897/NewsAI-React/blob/main/NewsAI.jpg?raw=true',
        demo:"https://news-ai-react.vercel.app/",
        github:"https://github.com/marins1897/NewsAI-React",

    },
    {
        id:4,
        name:"Food Bonnie App",
        description:["Order food App, with cart, list of meals and detail of order. Build with React.js and Firebase."],
       
       
       
        imgSrc:'https://github.com/marins1897/FoodBonnieApp/blob/main/FoodApp.jpg?raw=true',
        
        demo:"https://food-bonnie-app.vercel.app/",
        github:"https://github.com/marins1897/FoodBonnieApp",
     
        
    },
    {
        id:5,
        name:"Redux Shop",
        description:["A small React Redux shop with Firebase. Message about cart state displayed in case of Error, Sending or Success message."],
       
        imgSrc:'https://github.com/marins1897/ReduxShop/blob/main/Redux-Shop.jpg?raw=true',
        demo:"https://redux-shop-six.vercel.app//",
        github:"https://github.com/marins1897/ReduxShop",
   
    },
    {
        id:6,
        name:"NK Croatia Zmijavci",
        description:["Unofficial website for football club build using PHP, HTML, Javascript and MySql. Admin dashboard with Publish, Edit and Delete Post, User, Match.."],
       
        imgSrc:'https://github.com/marins1897/CroatiaZ/blob/main/NKCroatia1.jpg?raw=true',
        demo:"http://www.nkcroatiazmijavci.rf.gd/",
        github:"https://github.com/marins1897/CroatiaZ",
       
       
    },{
        id:7,
        name:"Meetups App",
        description:["Fill the form with new Meetup. List of inputed Meetups displayed on Main Page. Build using Next.js and MongoDB. "],
       
        imgSrc:'https://github.com/marins1897/meetups-nextjs/blob/main/Meetups-NextJS.jpg?raw=true',
        demo:"https://meetups-nextjs-ashen.vercel.app/",
        github:"https://github.com/marins1897/meetups-nextjs",
     
        
    },
    {
        id:8,
        name:"Quotes SPA",
        description:["Quotes Single Page Application builded using React Router and Firebase. Sort Qoutes, Add New Quote, Load and Add Comments."],
       
        imgSrc:'https://github.com/marins1897/Quotes-SPA/blob/main/Quotes.jpg?raw=true',
        demo:"https://router-95b86.web.app/quotes",
        github:"https://github.com/marins1897/Quotes-SPA",
     
    },
    {
        id:9,
        name:"Weather App",
        description:["Weather forecast App. Display current weather in typed city and forecast for next few days. Build with React.js and Bootstrap."],
       
        imgSrc:'https://github.com/marins1897/WeatherApp/blob/main/Weather.jpg?raw=true',
        demo:"https://weather-app-bice-nu.vercel.app/",
        github:"https://github.com/marins1897/WeatherApp",
     
    },{
        id:10,
        name:"Expense Filter App",
        description:["App build in React.js. With add new expense funcionallity, expenses filtered by month."],
       
        imgSrc: 'https://github.com/marins1897/Expenses-filter/blob/main/ExpensesFilter111.jpg?raw=true',
        demo:"https://expenses-filter-orpin.vercel.app/",
        github:"https://github.com/marins1897/Expenses-filter",

    },
    {
        id:11,
        name:"Movie App",
        description:["Add Movie Title, Opening text and Release date. Movie will be added to Firebase, fetched from there and displayed."],
       
        imgSrc:'https://github.com/marins1897/add-fetch-Movie-http/blob/main/Movie.jpg?raw=true',
        demo:"https://add-fetch-movie-http.vercel.app/",
        github:"https://github.com/marins1897/add-fetch-Movie-http",
     
    },
    {
        id:12,
        name:"Personal Portfolio App",
        description:["Personal portfolio made by using React.js , styled components and React Motion."],
       
        imgSrc:'https://github.com/marins1897/PortfolioMS/blob/main/PortfolioMS.jpg?raw=true',
        demo:"https://marins.vercel.app/",
        github:"https://github.com/marins1897/PortfolioMS",
     
    },
    {
        id:13,
        name:"Authentication App",
        description:["React Authentication App with Firebase and Firebase REST API. Using the token for request to protected resources and adding auto log out."],
       
        imgSrc:'https://github.com/marins1897/Authentication/blob/main/Authentication.jpg?raw=true',
        demo:"https://authentication-nine.vercel.app/",
        github:"https://github.com/marins1897/Authentication",
     
    },
    {
        id:14,
        name:"To Do App",
        description:["To Do App builded with Typescript and React.js."],
       
        imgSrc:'https://github.com/marins1897/ToDoApp-Typescript/blob/main/ToDoTypeScript.jpg?raw=true',
        demo:"https://to-do-app-typescript.vercel.app/",
        github:"https://github.com/marins1897/ToDoApp-Typescript",
     
    },
    {
        id:15,
        name:"Redux Auth",
        description:["Authentication and Counter App build with React Redux and Redux Toolkit."],
       
        imgSrc:'https://github.com/marins1897/Redux-auth/blob/main/ReduxAuth.jpg?raw=true',
        demo:"https://redux-auth.vercel.app/",
        github:"https://github.com/marins1897/Redux-auth",
     
    },
    {
        id:16,
        name:"Forms And User Input",
        description:["Working with forms and user input in React.js. Validating user input and providing validation feedback."],
       
        imgSrc:'https://github.com/marins1897/React-Form-and-UserInput-Validation/blob/main/FormsAndUserInput.jpg?raw=true',
        demo:"https://react-form-and-user-input-validation.vercel.app/",
        github:"https://github.com/marins1897/React-Form-and-UserInput-Validation",
     
    },
    {
        id:17,
        name:"Visit Otok",
        description:["Website for tourist agency Visit Otok. Made by using HTML, CSS and Javascript. School project."],
       
        imgSrc:'https://github.com/marins1897/VisitOtok/blob/main/seminar/VisitOtok.jpg?raw=true',
        demo:"/work",
        github:"https://github.com/marins1897/VisitOtok/tree/main/seminar",
     
    },
    {
        id:18,
        name:"Login User",
        description:["Login User to Some Page with React Hooks, useContext, useReducer and useEffect."],
       
        imgSrc:'https://github.com/marins1897/LoginLogout-from-SomePage/blob/main/Login.jpg?raw=true',
        demo:"https://login-logout-from-some-page.vercel.app/",
        github:"https://github.com/marins1897/LoginLogout-from-SomePage",
     
    },
    {
        id:19,
        name:"Animation Modal",
        description:["Using React Transition Group. "],
       
        imgSrc:'https://github.com/marins1897/AnimationsModal/blob/main/Animations.jpg?raw=true',
        demo:"https://animations-modal.vercel.app/",
        github:"https://github.com/marins1897/AnimationsModal",
     
    },
    {
        id:20,
        name:"Favorite App",
        description:["Click on Product to make it Favorite. Made with custom Hooks."],
       
        imgSrc:'https://github.com/marins1897/Favorites-customHook/blob/main/Favorite.jpg?raw=true',
        demo:"https://favorites-custom-hook.vercel.app/",
        github:"https://github.com/marins1897/Favorites-customHook",
     
    },
    {
        id:21,
        name:"Ingredients ",
        description:["Ingredient App made with React custom Hook. Add new Ingredient, filter ingredients and fetch and load ingredients with Firebase."],
       
        imgSrc:'https://github.com/marins1897/IngredientsList/blob/main/Ingredients.jpg?raw=true',
        demo:"https://ingredients-list-gamma.vercel.app/",
        github:"https://github.com/marins1897/IngredientsList",
     
    },
    {
        id:22,
        name:"Add User App",
        description:["Add new User by submitting Form. Made with React useState."],
       
        imgSrc:'https://github.com/marins1897/AddUser/blob/main/AddUser.jpg?raw=true',
        demo:"https://add-user-psi.vercel.app/",
        github:"https://github.com/marins1897/AddUser",
     
    },
    {
        id:23,
        name:"Goal App",
        description:["Add new goal. Made with React useState. Styling invalid input with CSS modules."],
       
        imgSrc:'https://github.com/marins1897/Add-InvalidInput/blob/main/Goal.jpg?raw=true',
        demo:"https://add-invalid-input.vercel.app/",
        github:"https://github.com/marins1897/Add-InvalidInput",
     
    },
    {
        id:24,
        name:"Portfolio",
        description:["Personal portfolio made with HTML, CSS, Javascript."],
       
        imgSrc:'https://github.com/marins1897/Marin/blob/main/Portfolio.jpg?raw=true',
        demo:"http://www.marinsamardzic.ga/",
        github:"https://github.com/marins1897/Marin",
     
    },
    {
        id:25,
        name:"Show Hide User",
        description:["Show and Hide Added User made with React class based components."],
       
        imgSrc:'https://github.com/marins1897/Add-Hide-User/blob/main/ShowHide.jpg?raw=true',
        demo:"https://add-hide-user-eakacqr1k-marins1897.vercel.app/",
        github:"https://github.com/marins1897/Add-Hide-User",
     
    },
     {
        id:26,
        name:"To Do",
        description:["To Do App builded by React Custom hook. Tasks added to Firebase and fetched."],
       
        imgSrc:'https://github.com/marins1897/ToDo-List-customHook/blob/main/CustomToDo.jpg?raw=true',
        demo:"https://to-do-list-custom-hook.vercel.app/",
        github:"https://github.com/marins1897/ToDo-List-customHook",
     
    },

] 
